import React from 'react'
import image from '../../../../assets/homepage_brand1.png';
import image2 from '../../../../assets/homepage_brand2.png';
import image3 from '../../../../assets/Homepage_brand3.png';
const LowerLogoCarousel = () => {
    return (
        <>
            <section className="">
                <ul className="brand-lst d-flex justify-content-between">
                    <li>
                        <img className="img-fluid" src={image} alt="" />
                    </li>
                    <li>
                        <img className="img-fluid" src={image2} alt="" />
                    </li>
                    <li>
                        <img className="img-fluid" src={image3} alt="" />
                    </li>
                    <li>
                        <img className="img-fluid" src={image} alt="" />
                    </li>
                    <li>
                        <img className="img-fluid" src={image2} alt="" />
                    </li>
                    <li>
                        <img className="img-fluid" src={image3} alt="" />
                    </li>
                    <li>
                        <img className="img-fluid" src={image} alt="" />
                    </li>
                    <li>
                        <img className="img-fluid" src={image2} alt="" />
                    </li>
                </ul>
            </section>

        </>
    )
}

export default LowerLogoCarousel